/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable import/order */
import React, { useState } from 'react'
import {
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ReactInputMask from 'react-input-mask'

import FormSection from './FormSection'
import { isCpfCnpjValid } from '../../../../util/cpf_cnpj_validator'

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
})

const FormGroupUser = () => {
  const classes = useStyles()

  const [cpfCnpj, setCpfCnpj] = useState({
    error: false,
    text: 'Digite um CPF',
  })

  const [values, setValues] = useState({
    showPassword: false,
  })

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword })
  }

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  const handleValidCpfCnpj = e => {
    const digits = e.target.value.replace(/[^\d]/g, '')

    if (!digits.length) {
      return setCpfCnpj({ error: false, text: 'Digite um CPF' })
    }

    if (digits.length != 11) {
      return setCpfCnpj({ error: true, text: 'Informe o CPF completo' })
    }

    if (!isCpfCnpjValid(e.target.value)) {
      return setCpfCnpj({ error: true, text: 'CPF inválido' })
    }

    return setCpfCnpj({ error: false, text: '' })
  }

  return (
    <FormSection
      title="Dados do gerente"
      caption="Estes serão os dados de acesso do usuário responsável pela conta."
    >
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Nome"
            name="manager_name"
            required
            fullWidth
            inputProps={{ maxLength: 255 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="E-mail"
            type="email"
            name="manager_email"
            required
            fullWidth
            inputProps={{ maxLength: 255 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <ReactInputMask
            mask="999.999.999-99"
            maskChar=""
            name="manager_cpf"
            onBlur={handleValidCpfCnpj}
            required
          >
            {inputProps => (
              <TextField
                {...inputProps}
                label="CPF"
                fullWidth
                error={cpfCnpj?.error}
                helperText={cpfCnpj?.text}
              />
            )}
          </ReactInputMask>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="manager_password"
            label="Senha"
            fullWidth
            required
            type={values.showPassword ? 'text' : 'password'}
            InputProps={{
              inputProps: { maxLength: 255 },
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip
                    title={
                      !values.showPassword ? 'Revelar senha' : 'Esconder senha'
                    }
                    aria-label="password"
                  >
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </FormSection>
  )
}

export default FormGroupUser
